import discardFields from './discardFields';

export default discardFields;
